import React from 'react';
import { Pagination } from '@codametrix/ui-components';
import './styles/index.scss';
export type StandalonePageableListProps = {
  children: React.ReactNode;
  sortablePageable: CMxCommonApp.SortablePageable<any>;
  theme?: string;
  list: (options?: CMxCommonApp.SortablePageable<any>) => void;
};

export const StandalonePageableList: React.FC<StandalonePageableListProps> = ({
  children,
  sortablePageable,
  theme,
  list = (options?: CMxCommonApp.SortablePageable<any>) => {}
}: StandalonePageableListProps) => {
  const { pageableDefinition: pageable } = sortablePageable;
  const onPaginationClick = (action: any) => {
    const {
      pageableDefinition: pageable,
      sortableOptions,
      filterableOptions
    } = sortablePageable;

    const retAction: CMxCommonApp.SortablePageable<any> = {
      pageableDefinition: {
        ...pageable,
        pageable: {
          ...pageable.pageable,
          pageNumber: action.index,
          pageSize: action.size
        }
      },
      sortableOptions,
      filterableOptions
    };
    list(retAction);
  };

  return (
    <div className="standalone-pageable">
      <div className="pageable-list">{children}</div>
      <div className="pagination-controls">
        <Pagination
          pageable={pageable}
          onSelect={onPaginationClick}
          theme={theme}
        />
      </div>
    </div>
  );
};

StandalonePageableList.displayName = 'StandalonePageableList';
